import type { Plan } from "@productlane/lib/src/browser"
import { planHierarchy } from "@productlane/lib/src/browser"

export function shouldShowPlanPill({
	requiredPlan,
	effectivePlan,
	isTrial,
}: {
	requiredPlan: Plan
	effectivePlan: string | undefined
	isTrial: boolean
}) {
	if (!effectivePlan) {
		return false
	}
	if (isTrial) {
		return true
	}
	const currentIndex = planHierarchy.indexOf(effectivePlan as Plan)
	if (currentIndex === -1) {
		return true
	}
	return currentIndex < planHierarchy.indexOf(requiredPlan)
}
